import React, { useEffect, useState, useContext } from 'react'
// NAVIGATION
import { useNavigate, Link } from 'react-router-dom'
// FIREBASE
import useFirebase from '../../../firebase/useFirebase'
import { ref, query, onValue, equalTo, orderByChild } from "firebase/database"
import database from '../../../firebase/base'
// APP CONTEXT
import { AppContext } from '../../../App'
// COMPONENTS
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
import Spinner from '../../../components.js/elements/Spinner'
// IMAGES
import imageChat from '../../../images/chat.png'

const Chat = () => {
    const { user } = useContext(AppContext)
    const { readData, readDataMessagesChat, profil, count, messagesChat, clients } = useFirebase()
    const [montage, setMontage] = useState(true)
    let navigate = useNavigate()

    useEffect(() => { 
        readData(user.uid)
        readDataMessagesChat(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[count])

    if (montage) return <Spinner />

    const _filtreNewMessages = () => {
        const array = []
        const starCountRef = query(ref(database, 'entreprises/'+user.uid+'/messagesChat'), orderByChild("isNew"),  equalTo(true))
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                for (let id in data) {
                    array.push({id,...data[id]})
                }
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        } 
        return array
    }

    return (
        <div className='container-fluid'>
            <HeaderReturn title='Chat' image={imageChat} link='/homeServeur' />

            <div className='mt-4'/>

            {/* NOUVEAU MESSAGES */}
            <div className='row'>
                {clients.sort((a,b) => a.name > b.name ? 1 : -1).map(cl => (
                    _filtreNewMessages().filter(t => t.uidClient === cl.uid && t.receiver === 'administrateur').map(tf => tf.id).length === 0 ? null :
                    messagesChat.filter(mes => mes.uidClient === cl.uid && mes.isNew).reverse().map((mes,i) => (
                        i === 0 && 
                        <Link to='/chatSingle' className='text-decoration-none' style={{ color:'black' }} state={{ uidClient:cl.uid, nameClient:cl.name, surnameClient:cl.surname }}>
                            <div className='row align-items-center border-bottom pb-2 mt-1' key={cl.id}>
                                <div className='col-11'>
                                    <div>{cl.name} {cl.surname}</div>
                                    <div><span style={{ color:'green', fontStyle:'italic' }}>new</span> {mes.message}</div>
                                </div>
                                <div className='col-1'><i class="bi bi-arrow-right"></i></div>
                            </div>
                        </Link>
                    ))
                ))}
            </div>

            {/* ANCIENS MESSAGES */}
            <div className='row'>
                {clients.sort((a,b) => a.name > b.name ? 1 : -1).map(cl => (
                    _filtreNewMessages().filter(t => t.uidClient === cl.uid && t.receiver === 'administrateur').map(tf => tf.id).length === 0 ? 
                    messagesChat.filter(mes => mes.uidClient === cl.uid).reverse().map((mes,i) => (
                        i === 0 && 
                        <Link to='/chatSingle' className='text-decoration-none' style={{ color:'black' }} state={{ uidClient:cl.uid, nameClient:cl.name, surnameClient:cl.surname }}>
                            <div className='row align-items-center border-bottom pb-2 mt-1' key={cl.id}>
                                <div className='col-11'>
                                    <div>{cl.name} {cl.surname}</div>
                                    <div>{mes.message}</div>
                                </div>
                                <div className='col-1 text-end'><i class="bi bi-arrow-right"></i></div>
                            </div>
                        </Link>
                    ))
                    : null
                ))}
            </div>

        </div>
    )
}

export default Chat

